import DOMPurify from "dompurify";

export function decodeBase64ToText(baseContent: string): string {
    const binaryString = atob(baseContent);
    const bytes = Uint8Array.from(binaryString, c => c.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
}

export function sanitizeHtml(content: string) {
    return DOMPurify.sanitize(content);
}

export function getUsernameInitials (name?: string | null, maxLength = 2): string {
    const noName = '?';

    if (!name) return noName;

    const base = name.split('@')[0].trim();
    const parts = base.trim().split(/[\s._-]+/).filter(Boolean);

    if (parts.length === 0) return noName;
    if (parts.length === 1) return Array.from(parts[0])[0].toUpperCase();
    return parts
        .slice(0, maxLength)
        .map((p) => Array.from(p)[0].toUpperCase())
        .join('');
}